import { API_HOST_NAME } from '../constants.js'
import useAuthenticatedResources from '../../../useAuthenticatedResources.js'

const useNodeFeaturesResources = (teamId, nodeId) => {
  const url = `${API_HOST_NAME}/api/v1/admin/teams/${teamId}/nodes/${nodeId}/node_features`
  return useAuthenticatedResources(url)
}

export default useNodeFeaturesResources
